import { GatewayAnchor, GatewayVersion } from 'src/models/anchor-and-version/gateway.model';
import { createBaseAnchor, createBaseVersion } from './base.factory';
import { deepCopy, getDistinctArr } from 'src/utils/other.util';
import { ComponentAnchor } from 'src/models/anchor-and-version/component.model';
import { SegmentAnchor } from 'src/models/anchor-and-version/segment.model';

export function createGatewayAnchor(
    aParams: {
        // Base
        logText: string;
        // Specific
        componentAnchorKey?: number;
        fvBoxAnchorKey: number;
        segmentAnchorKey: number;
        position: number;
        // Virtual
        componentAnchor?: ComponentAnchor;
        segmentAnchor?: SegmentAnchor;
    },
    vParams: {
        // Base
        changeRequestKey: number;
        comment: string;
        isActive: boolean;
        logText: string;
        name: string;
    }
): GatewayAnchor {
    const validVersion = createGatewayVersion({ ...vParams, anchorKey: 0 });
    const firstVersion = deepCopy(validVersion);
    firstVersion.isActive = false;
    firstVersion.changeRequestKey = 1;
    const versions = getDistinctArr([firstVersion, validVersion]);
    const anchor: GatewayAnchor = {
        ...createBaseAnchor(aParams),
        componentAnchorKey: aParams.componentAnchorKey ?? null,
        fvBoxAnchorKey: aParams.fvBoxAnchorKey,
        segmentAnchorKey: aParams.segmentAnchorKey,
        position: aParams.position,
        componentAnchor: aParams.componentAnchor ?? null,
        segmentAnchor: aParams.segmentAnchor ?? null,
        displayName: null,
        allVersions: versions,
        validVersion: validVersion,
    };

    return anchor;
}

export function createGatewayVersion(params: {
    // Base
    anchorKey: number;
    changeRequestKey: number;
    comment: string;
    isActive: boolean;
    logText: string;
    name: string;
}): GatewayVersion {
    const baseVersion = createBaseVersion(params);
    const version: GatewayVersion = {
        ...baseVersion,
        isActive: params.isActive,
    };

    return version;
}
